import { Center, CenterProps } from '@chakra-ui/react';
import { ReactNode } from 'react';

/**
 * @description A container box for a control that behaves like a button and a radio button
 * @prop children
 */
export interface RadioBoxProps extends CenterProps {
  children: ReactNode;
  isActive?: boolean;
}

export const RadioBox = ({ children, isActive, ...rest }: RadioBoxProps) => (
  <Center
    minH="40px"
    bg={isActive ? 'brand.additional.link' : 'white'}
    borderColor="brand.monochromatic.200"
    borderWidth="1px"
    borderRadius="4px"
    color={isActive ? 'white' : 'brand.additional.link'}
    cursor="pointer"
    fontSize={18}
    py={3}
    textTransform="capitalize"
    w="full"
    _hover={{ background: !isActive ? 'brand.monochromatic.100' : '' }}
    {...rest}
  >
    {children}
  </Center>
);
